var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { SdsButton } from '../button/default/sds-button.lit';
import { appendStylesToTheGlobalStyleRoot } from '../utilities/dom';
let SdsModalBase = (() => {
    var _a, _SdsModalBase_open_accessor_storage, _SdsModalBase_appendTo_accessor_storage, _SdsModalBase_preventOverlayClose_accessor_storage, _SdsModalBase_hideCloseButton_accessor_storage, _SdsModalBase_hidden_accessor_storage;
    let _classSuper = LitElement;
    let _open_decorators;
    let _open_initializers = [];
    let _open_extraInitializers = [];
    let _appendTo_decorators;
    let _appendTo_initializers = [];
    let _appendTo_extraInitializers = [];
    let _preventOverlayClose_decorators;
    let _preventOverlayClose_initializers = [];
    let _preventOverlayClose_extraInitializers = [];
    let _hideCloseButton_decorators;
    let _hideCloseButton_initializers = [];
    let _hideCloseButton_extraInitializers = [];
    let _hidden_decorators;
    let _hidden_initializers = [];
    let _hidden_extraInitializers = [];
    return _a = class SdsModalBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsModalBase_open_accessor_storage.set(this, __runInitializers(this, _open_initializers, false));
                _SdsModalBase_appendTo_accessor_storage.set(this, (__runInitializers(this, _open_extraInitializers), __runInitializers(this, _appendTo_initializers, void 0)));
                _SdsModalBase_preventOverlayClose_accessor_storage.set(this, (__runInitializers(this, _appendTo_extraInitializers), __runInitializers(this, _preventOverlayClose_initializers, false)));
                _SdsModalBase_hideCloseButton_accessor_storage.set(this, (__runInitializers(this, _preventOverlayClose_extraInitializers), __runInitializers(this, _hideCloseButton_initializers, false)));
                _SdsModalBase_hidden_accessor_storage.set(this, (__runInitializers(this, _hideCloseButton_extraInitializers), __runInitializers(this, _hidden_initializers, false)));
                this.modalContainer = (__runInitializers(this, _hidden_extraInitializers), document.createElement('div'));
                this.modalContentContainer = undefined;
                this.isReady = false;
                this._modalOverlay = document.createElement('div');
                this.closeModalHandler = (event) => {
                    if (event.target === this._modalOverlay ||
                        (event.target instanceof SdsButton &&
                            event.target.getAttribute('id') === 'modal-close-button')) {
                        // If clicking on overlay and preventOverlayClose is true, don't close
                        if (event.target === this._modalOverlay && this.preventOverlayClose) {
                            return;
                        }
                        this.closeModal();
                    }
                };
                this.keyboardCloseHandler = (event) => {
                    if (event.key === 'Escape') {
                        this.open = false;
                    }
                };
            }
            /**
             * Indicates the state of the modal.
             * This attribute reflects whether the modal is open or closed.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} open - If true, the modal is open.
             */
            get open() { return __classPrivateFieldGet(this, _SdsModalBase_open_accessor_storage, "f"); }
            set open(value) { __classPrivateFieldSet(this, _SdsModalBase_open_accessor_storage, value, "f"); }
            /**
             * Specifies where to append the modal in the DOM.
             * This attribute allows you to designate a specific element for the modal to attach to,
             * which can help with positioning and accessibility.
             *
             * Defaults to an empty string, meaning it will append to the body by default.
             *
             * @attr {string} append-to - The selector or ID of the element to append the modal to.
             */
            get appendTo() { return __classPrivateFieldGet(this, _SdsModalBase_appendTo_accessor_storage, "f"); }
            set appendTo(value) { __classPrivateFieldSet(this, _SdsModalBase_appendTo_accessor_storage, value, "f"); }
            /**
             * Prevents the modal from closing when clicking on the overlay.
             * When set to true, the modal will only close via the close button or ESC key.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} prevent-overlay-close - If true, prevents closing on overlay click.
             */
            get preventOverlayClose() { return __classPrivateFieldGet(this, _SdsModalBase_preventOverlayClose_accessor_storage, "f"); }
            set preventOverlayClose(value) { __classPrivateFieldSet(this, _SdsModalBase_preventOverlayClose_accessor_storage, value, "f"); }
            /**
             * Defaults to `false`.
             *
             * @attr {boolean} hide-close-button - If true, hides the close button.
             */
            get hideCloseButton() { return __classPrivateFieldGet(this, _SdsModalBase_hideCloseButton_accessor_storage, "f"); }
            set hideCloseButton(value) { __classPrivateFieldSet(this, _SdsModalBase_hideCloseButton_accessor_storage, value, "f"); }
            /**
             * Hides the modal overlay when set to true.
             * When set to true, the modal overlay will have display: none applied to it.
             * This is useful for temporarily hiding a modal while keeping it in the DOM.
             *
             * Defaults to `false`.
             *
             * @attr {boolean} hidden - If true, hides the modal overlay.
             */
            get hidden() { return __classPrivateFieldGet(this, _SdsModalBase_hidden_accessor_storage, "f"); }
            set hidden(value) { __classPrivateFieldSet(this, _SdsModalBase_hidden_accessor_storage, value, "f"); }
            async firstUpdated() {
                return this.onFirstUpdate();
            }
            disconnectedCallback() {
                var _b;
                (_b = this._modalOverlay) === null || _b === void 0 ? void 0 : _b.removeEventListener('mousedown', this.closeModalHandler);
                this.open = false;
                super.disconnectedCallback();
            }
            willUpdate(changedProperties) {
                if (changedProperties.has('open')) {
                    this.toggleModal();
                    if (this.open) {
                        document.addEventListener('keydown', this.keyboardCloseHandler);
                    }
                    else {
                        document.removeEventListener('keydown', this.keyboardCloseHandler);
                    }
                }
                if (changedProperties.has('size')) {
                    if (this.modalContainer) {
                        this.updateContainerSize();
                    }
                }
                if (changedProperties.has('hidden')) {
                    this.updateOverlayVisibility();
                }
            }
            closeModal() {
                if (this.isReady && !isNil(this.modalContentContainer)) {
                    const closestLayout = this.closest(this.appendTo);
                    if (closestLayout) {
                        closestLayout.classList.remove('sds-overlay-appended');
                    }
                    this._modalOverlay.removeEventListener('mousedown', this.closeModalHandler);
                    this._modalOverlay.remove();
                    this.open = false;
                    this.dispatchClosedEvent();
                }
            }
            onModalChange() {
                if (this.isReady) {
                    this.prepareModal();
                }
            }
            prepareModal() {
                if (this.modalContainer.className !== this.getContainerClass()) {
                    this.updateContainerSize();
                }
                if (isNil(this.modalContentContainer)) {
                    this.modalContentContainer = document.createElement('div');
                    this.modalContentContainer.className = this.getContainerBodyClass();
                }
                for (const item of this.getContent()) {
                    this.modalContentContainer.appendChild(item);
                }
                this.modalContainer.appendChild(this.modalContentContainer);
            }
            openModal() {
                if (!this._modalOverlay.isConnected) {
                    let closestLayout = null;
                    if (this.appendTo) {
                        closestLayout = this.closest(this.appendTo);
                        if (closestLayout) {
                            closestLayout.classList.add('sds-overlay-appended');
                            closestLayout.appendChild(this._modalOverlay);
                        }
                    }
                    if (!this.appendTo || !closestLayout) {
                        document.body.appendChild(this._modalOverlay);
                    }
                    this._modalOverlay.removeEventListener('mousedown', this.closeModalHandler);
                    this._modalOverlay.addEventListener('mousedown', this.closeModalHandler);
                }
                // Apply hidden state after modal is opened
                this.updateOverlayVisibility();
            }
            updateOverlayVisibility() {
                if (this._modalOverlay && this._modalOverlay.isConnected) {
                    if (this.hidden) {
                        this._modalOverlay.style.display = 'none';
                    }
                    else {
                        this._modalOverlay.style.display = '';
                    }
                }
            }
            dispatchClosedEvent() {
                this.dispatchEvent(new CustomEvent(_a.CLOSED_EVENT, {
                    bubbles: false,
                    composed: false,
                }));
            }
            prepareOverlay() {
                this._modalOverlay.className = 'sds-overlay';
                this._modalOverlay.appendChild(this.modalContainer);
            }
            updateContainerSize() {
                this.modalContainer.className = `${this.getContainerClass()} ${this.getSizeClass()}`;
            }
            toggleModal() {
                if (this.open) {
                    this.openModal();
                }
                else {
                    this.closeModal();
                }
            }
            async onFirstUpdate() {
                await this.updateComplete;
                appendStylesToTheGlobalStyleRoot(this.getComponentStyleId(), this.getGlobalStyles() + this.getStyles().cssText);
                this.prepareModal();
                this.prepareOverlay();
                this.dispatchOpenedEvent();
            }
            dispatchOpenedEvent() {
                this.dispatchEvent(new CustomEvent(_a.OPENED_EVENT, {
                    bubbles: false,
                    composed: false,
                }));
            }
        },
        _SdsModalBase_open_accessor_storage = new WeakMap(),
        _SdsModalBase_appendTo_accessor_storage = new WeakMap(),
        _SdsModalBase_preventOverlayClose_accessor_storage = new WeakMap(),
        _SdsModalBase_hideCloseButton_accessor_storage = new WeakMap(),
        _SdsModalBase_hidden_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _open_decorators = [property({ type: Boolean, reflect: true })];
            _appendTo_decorators = [property({ type: String, attribute: 'append-to' })];
            _preventOverlayClose_decorators = [property({ type: Boolean, attribute: 'prevent-overlay-close' })];
            _hideCloseButton_decorators = [property({ type: Boolean, attribute: 'hide-close-button' })];
            _hidden_decorators = [property({ type: Boolean, reflect: true })];
            __esDecorate(_a, null, _open_decorators, { kind: "accessor", name: "open", static: false, private: false, access: { has: obj => "open" in obj, get: obj => obj.open, set: (obj, value) => { obj.open = value; } }, metadata: _metadata }, _open_initializers, _open_extraInitializers);
            __esDecorate(_a, null, _appendTo_decorators, { kind: "accessor", name: "appendTo", static: false, private: false, access: { has: obj => "appendTo" in obj, get: obj => obj.appendTo, set: (obj, value) => { obj.appendTo = value; } }, metadata: _metadata }, _appendTo_initializers, _appendTo_extraInitializers);
            __esDecorate(_a, null, _preventOverlayClose_decorators, { kind: "accessor", name: "preventOverlayClose", static: false, private: false, access: { has: obj => "preventOverlayClose" in obj, get: obj => obj.preventOverlayClose, set: (obj, value) => { obj.preventOverlayClose = value; } }, metadata: _metadata }, _preventOverlayClose_initializers, _preventOverlayClose_extraInitializers);
            __esDecorate(_a, null, _hideCloseButton_decorators, { kind: "accessor", name: "hideCloseButton", static: false, private: false, access: { has: obj => "hideCloseButton" in obj, get: obj => obj.hideCloseButton, set: (obj, value) => { obj.hideCloseButton = value; } }, metadata: _metadata }, _hideCloseButton_initializers, _hideCloseButton_extraInitializers);
            __esDecorate(_a, null, _hidden_decorators, { kind: "accessor", name: "hidden", static: false, private: false, access: { has: obj => "hidden" in obj, get: obj => obj.hidden, set: (obj, value) => { obj.hidden = value; } }, metadata: _metadata }, _hidden_initializers, _hidden_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.CLOSED_EVENT = 'sds.modal.closed',
        _a.OPENED_EVENT = 'sds.modal.opened',
        _a;
})();
export { SdsModalBase };
